import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Globe } from 'lucide-react';
import { useUnit } from '../contexts/UnitContext';
import { ALL_UNITS } from '../lib/api';

export default function UnitPicker() {
  const { allowedUnits, setActiveUnit, canSwitch } = useUnit();
  const navigate = useNavigate();

  useEffect(() => {
    // Locked users, or anyone with a single unit, skip the picker.
    if ((!canSwitch || allowedUnits.length === 1) && allowedUnits.length >= 1) {
      setActiveUnit(allowedUnits[0]);
      navigate('/', { replace: true });
    }
    // eslint-disable-next-line
  }, [allowedUnits, canSwitch]);

  const choose = (u) => { setActiveUnit(u); navigate('/', { replace: true }); };
  const realUnits = allowedUnits.filter((u) => u !== ALL_UNITS);
  const hasAll = canSwitch && allowedUnits.includes(ALL_UNITS);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F8FB] p-6" data-testid="unit-picker">
      <div className="w-full max-w-2xl">
        <h1 className="text-2xl font-bold text-center text-[#11182B] mb-1">Select a unit</h1>
        <p className="text-sm text-center text-[#5A6377] mb-8">Choose which unit&apos;s workspace to open.</p>

        {hasAll && (
          <button onClick={() => choose(ALL_UNITS)} data-testid="unit-card-all-units"
            className="w-full mb-4 rounded-[14px] p-6 text-left border-2 border-transparent hover:border-[#E11D2A] hover:shadow-lg transition-all text-white"
            style={{ background: 'linear-gradient(135deg,#0C1B57 0%,#15307F 60%,#2563EB 100%)' }}>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-white/15 flex-shrink-0">
                <Globe className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <div>
                <h3 className="text-lg font-semibold">All Units — Corporate HQ</h3>
                <p className="text-xs text-[#AFC0E8] mt-1">Manage every unit&apos;s employees, salaries and org charts in one window</p>
              </div>
            </div>
          </button>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {realUnits.map((u) => (
            <button key={u} onClick={() => choose(u)} data-testid={`unit-card-${u}`}
              className="bg-white border border-[#E6E9F0] rounded-[14px] p-6 text-left hover:border-[#2563EB] hover:shadow-md transition-all">
              <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-3 text-white"
                   style={{ background: 'linear-gradient(135deg,#15307F,#2563EB)' }}>
                <Building2 className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <h3 className="text-lg font-semibold text-[#11182B]">{u}</h3>
              <p className="text-xs text-[#5A6377] mt-1">Open workspace</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
